module.exports = __webpack_public_path__ + "img/layout-1.3e0c2cd3.jpg";